<template>
</template>

<script>
export default {
    mounted() {
        // 入力があったらinvalidクラス削除
        const form = document.getElementById('form');
        if(form){
            const inputs = form.querySelectorAll('input, textarea, select');
            inputs.forEach((input) => {
                input.addEventListener('input', (event) => {
                    if (input.type === 'radio') {
                        const parent = input.closest('.radio-input');
                        if (parent) {
                            parent.classList.remove('invalid');
                        }
                    } else {
                        event.target.classList.remove('invalid');
                    }
                    event.target.setCustomValidity('');
                });
            });
        }
    },
}
</script>